<div class="wrapper" *ngIf="opened">
  <div class="container">
    <div class="row-1">
      <input
        class="search-input"
        placeholder="Rechercher dans sqi.gouv.qc.ca"
      />
      <div class="search-button" type="submit">
        <img src="assets/images/search.svg" class="search-icon" />
      </div>
    </div>
    <div class="row-2"><div class="submit-button">Recherche avancée</div></div>
  </div>
</div>
